import React from "react";
import styles from "./SummerSaleHero.module.scss";
import background from "images/heros/Summer Sale/background.jpg";
import titleImage from "images/heros/Summer Sale/Summer30.png";
import cityImage from "images/heros/Summer Sale/CityScape.png";

import { getGameList } from "constants/GameListAdapter";
import MiniGameCard from "components/Heros/MiniGameCard/MiniGameCard";


const StackedImages = () => {
    return (
        <div className={styles.stackedImagesContainer}>
            <img src={background} className={styles.bgImage} alt="Background" />
            <div className={styles.Games}>
                {
                    getGameList().filter(g => g.showInHero && g.status === "enabled").map(g => {
                        return <MiniGameCard game={g} key={g.gameId} showAddToCart={true} discountCode="SUMMER30" discountPercentage={30} />
                    })
                }
            </div>
            <img src={cityImage} className={styles.bottomImage} alt="City" />
            <img src={titleImage} className={styles.textImage} alt="Sale Text" />
            <h2 className={styles.title}> Super Summer Sale </h2>
        </div>
    );
};

export default StackedImages;